import { Injectable } from '@angular/core';
import { Validators } from '@angular/forms';
import { LocalstorageService } from 'src/app/global/localstorage.service';

@Injectable({
  providedIn: 'root'
})
export class Validations {
  getlen: string;
  isreq: string = "H";
  isAl: string = ' must contain only letters';
  constructor(){
    this.getlen = LocalstorageService.getLanguage("language");
  }
  ngOnInit(){
    if (this.getlen == 'en')
    {
      this.isreq = "is required";
    }
    else if (this.getlen == 'mr')
    {
      this.isreq = "आवश्यक आहे";
    }
  }
  public isR: { type: 'req', message: ' is req'};
  public static message = {
    isRequired: [
      { type: 'required', message: ' is required' },
    ],
    isAlpha: [
      { type: 'pattern', message: ' must contain only letters' }
    ],
    isNumeric: [
      { type: 'pattern', message: ' must contain only numbers' }
    ],
    isAlphaNumeric: [
      { type: 'pattern', message: ' must contain only letters and numbers' }
    ],
    isValidEmail: [
      { type: 'required', message: ' is required' },
      { type: 'email', message: ' is not valid' }
    ],
    isValidMobile: [
      { type: 'pattern', message: ' is not valid' }
    ],
    isAlphaRequired: [
      { type: 'required', message: ' is required' },
      { type: 'pattern', message: ' must contain only letters' }
    ],
    isNumericRequired: [
      { type: 'required', message: ' is required' },
      { type: 'pattern', message: ' should be valid' }
    ],
    isPasswordRequired: [
      { type: 'required', message: ' is required' },
      { type: 'pattern', message: ' must contain capital letter and small letter and number and special character and minimum 9 character long' }
    ],
    isAlphaNumericRequired: [
      { type: 'required', message: ' is required' },
      { type: 'pattern', message: ' must contain only letters and numbers' }
    ],
    isValidEmailRequired: [
      { type: 'required', message: ' is required' },
      { type: 'email', message: ' is not valid' }
    ],
    isValidMobileRequired: [
      { type: 'required', message: ' is required' },
      { type: 'pattern', message: ' is not valid' }
    ]
  };

  public static isAlpha() {
    return Validators.compose([
      Validators.pattern('[a-zA-Z ]*')
    ]);
  }

  public static isNumeric() {
    return Validators.compose([
      Validators.pattern('[0-9]*')
    ]);
  }

  public static isAlphaNumeric() {
    return Validators.compose([
      Validators.pattern('[a-zA-Z0-9 ]*')
    ]);
  }

  public static isValidEmail() {
    return Validators.compose([
      Validators.email,
      Validators.required

    ]);
  }

  public static isValidMobile() {
    return Validators.compose([
      Validators.pattern('[6-9]\\d{9}')
    ]);
  }

  public static isAlphaRequired() {
    return Validators.compose([
      Validators.required,
      Validators.pattern('[a-zA-Z ]*')
    ]);
  }

  public static isNumericRequired() {
    return Validators.compose([
      Validators.required,
      Validators.pattern('[0-9]*')
    ]);
  }

  public static isAlphaNumericRequired() {
    return Validators.compose([
      Validators.required,
      Validators.pattern('[a-zA-Z0-9 ]*')
    ]);
  }

  public static isValidEmailRequired() {
    return Validators.compose([
      Validators.required,
      Validators.email
    ]);
  }

  public static isValidMobileRequired() {
    return Validators.compose([
      Validators.required,
      //Validators.pattern('[6-9]\\d{11}')
      Validators.pattern('[6-9]\\d{9,14}')
    ]);
  }

  public static isPasswordRequired() {
    return Validators.compose([
      Validators.required,
      // Validators.pattern('[a-zA-Z0-9 ]*')
      Validators.pattern('(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[$@$!%*?&])[A-Za-z\d$@$!%*?&].{8,}')
    ]);
  }


  public static isRequired(){
    return Validators.compose([
      Validators.required
    ]);
  }
}
